import { render, staticRenderFns } from "./CurriculumT.vue?vue&type=template&id=5edae2ab&scoped=true&"
import script from "./CurriculumT.vue?vue&type=script&lang=ts&"
export * from "./CurriculumT.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumT.vue?vue&type=style&index=0&id=5edae2ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edae2ab",
  null
  
)

export default component.exports